export function disableBrowserZoom() {
  // Prevent Ctrl/Cmd + Plus/Minus/0
  document.addEventListener("keydown", (e) => {
    if (
      (e.ctrlKey || e.metaKey) &&
      (e.key === "+" || e.key === "-" || e.key === "=" || e.key === "0")
    ) {
      e.preventDefault();
    }
  });

  // Prevent zoom via Ctrl/Cmd + Scroll
  document.addEventListener(
    "wheel",
    (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    },
    { passive: false },
  );

  // Prevent trackpad pinch gestures
  document.addEventListener("gesturestart", (e) => {
    e.preventDefault();
  });

  document.addEventListener("gesturechange", (e) => {
    e.preventDefault();
  });

  document.addEventListener("gestureend", (e) => {
    e.preventDefault();
  });
}
